import React from "react";

interface IProps
{
    message: string | string[];
}

const AppUnavailableView = (props: IProps) =>
{
    return  <section className="h-100 content-block set-bg-white fixed-top">
        <div className="h-100 position-relative">
            <div className="absolute-middle w-100">
                <div className="container">

                    <div className="row">

                        <div className="col-12 text-center">
                            <h3>
                                Sorry, this application cannot be loaded at this time
                            </h3>
                        </div>
                    </div>
                    <div className="row">

                        <div className="col-12 text-center">
                            {(() =>
                            {
                                const messages: string[] = props.message ? (Array.isArray(props.message) ? props.message : [props.message]) : [];
                                if (!messages.length)
                                {
                                    return <></>;
                                }
                                return <>
                                    <div>
                                        {messages.map((message, index) =>
                                        {
                                            return <p key={index}>
                                                {message}
                                            </p>
                                        })}
                                    </div>
                                </>;
                            })()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>;
};

export default AppUnavailableView;